class RotatableImage {
  bind() {
    $('html').on('click', '.rotatable-image .rotatable-image-handle', event => {
      event.preventDefault();
      $(event.currentTarget).trigger('rotatableImage:rotate');
    });

    $('html').on('rotatableImage:rotate', '.rotatable-image', this.rotate);
  }

  rotate(event) {
    let $element = $(event.currentTarget);

    let currentAngle = $element.attr('data-rotate') || 0;
    let angle = ( parseInt(currentAngle, 10) + 90 ) % 360;

    $element.attr('data-rotate', angle);
    $element.find('input.rotatable-image-rotate-value').val(angle);
  }
}

let rotatableImage = new RotatableImage();
rotatableImage.bind();

module.exports = rotatableImage;
